<template>
    <span v-if="getAvailableForWarning() !== ''" class="appearance-none text-xs font-bold leading-none text-red-500">{{ getAvailableForWarning() }}</span>
</template>

<script setup lang="ts">
    import type { AvailableForProps } from '~/types/local-types'
    const props = defineProps<AvailableForProps>()
    const { t } = useI18n()

    function getAvailableForWarning () {
        if (props.availableFor === 'pickup_only') {
            return t('shopPage.product.availableFor.pickupOnly')
        } else if (props.availableFor === 'deliver_only') {
            return t('shopPage.product.availableFor.deliverOnly')
        }
        return ''
    }
</script>
